import { IconInterface } from '../interfaces/icon.interface';

const SimpleFile = (props: IconInterface) => {
	const {
		color = '#8B8B8B',
		width = 18,
		height = 18,
		strokeWidth = '1.4',
	} = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="3"
				y="1.8"
				width="10"
				height="12.4"
				rx="2"
				stroke={color}
				strokeWidth={strokeWidth}
				vectorEffect="non-scaling-stroke"
			/>
			<path
				d="M5.6 6h4.8M5.6 8.8h3.4"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				vectorEffect="non-scaling-stroke"
			/>
		</svg>
	);
};

export default SimpleFile;
